module.exports = __webpack_public_path__ + "static/media/Total_Range.5aac253b.svg";